import React, { useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { TableWithPagination } from "../../globalComponents/TableWithPagination";
import { ToolBar } from "../../globalComponents/ToolBar";
import { Menu, Popover, Space, Form } from "antd";
import { StyledCard, StyledModal } from "../../globalComponents/styles";
import { useRouteMatch, Route, Switch, useHistory } from "react-router";
import { selectTransfarOrder, getAllTransfarOrder } from "./slice";

import { AddTransferOrder } from "./AddTransferOrder";
import { useSelector, useDispatch } from "react-redux";
import { SpaceBar } from "@material-ui/icons";
import { FiMoreVertical } from "react-icons/fi";
import { DeleteModal } from "../../globalComponents/deleteModal";
import Services from "../../../services";
import { notificationAlert } from "../../utils/notificationAlert";
import { themes } from "../../globalAssets/theme";

// const data = [
//   {
//     item: "Building",
//     itemId: "00009",
//     itemClass: "Stock Item",
//     unitCost: "30000",
//     unitPrice: "15000",
//     stockOnHand: 23000,
//   },
//   {
//     item: "Building",
//     itemId: "00009",
//     itemClass: "Stock Item",
//     unitCost: "30000",
//     unitPrice: "15000",
//     stockOnHand: 23000,
//   },
//   {
//     item: "Building",
//     itemId: "00009",
//     itemClass: "Stock Item",
//     unitCost: "30000",
//     unitPrice: "15000",
//     stockOnHand: 23000,
//   },
//   {
//     item: "Building",
//     itemId: "00009",
//     itemClass: "Stock Item",
//     unitCost: "30000",
//     unitPrice: "15000",
//     stockOnHand: 23000,
//   },
//   {
//     item: "Building",
//     itemId: "00009",
//     itemClass: "Stock Item",
//     unitCost: "30000",
//     unitPrice: "15000",
//     stockOnHand: 23000,
//   },
// ];

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

export const TransferOrder = (props) => {
  const dispatcher = useDispatch();

  //useSelector
  const { transfarOrderList, paginationProps } =
    useSelector(selectTransfarOrder);

  const [page, setPage] = React.useState(2);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const [searchItem, setSearchItem] = useState({});
  const [editGroupForm] = Form.useForm();

  const [editModalProps, setEditModalProps] = useState({
    isVisible: false,
    selectedItemInput: [],
    loading: false,
    initialValues: {},
  });
  const [deleteModalProps, setDeleteModalProps] = useState({
    visible: false,
    name: "",
    id: null,
    loading: false,
  });

  const [feedbackProps, setFeedbackProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const columns = [
    // {
    //   title: "S/N",
    //   dataIndex: "sn",
    //   key: "sn",
    // },
    {
      title: "Transfer Date",
      dataIndex: "transferDate",
      key: "transferDate",
      render: (data) => {
        return moment(data).format("dddd, MMMM Do, YYYY");
      },
    },
    {
      title: "transferred Quantity",
      dataIndex: "transferredQuantity",
      key: "transferredQuantity",
    },
    {
      title: "Ref No",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
    },
    {
      title: "Source Warehouse",
      dataIndex: "sourceWarehouse",
      key: "sourceWarehouse",
    },
    {
      title: "Destination Warehouse",
      dataIndex: "destinationWarehouseUuid",
      key: "destinationWarehouseUuid",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "5%",
      render: (data, allData) => {
        const content = (
          <Space direction="vertical" size="small">
            {/* <p
              style={{ cursor: "pointer" }}
              onClick={() => history.push(`${url}/${allData.id}`)}
            >
              View Detail
            </p> */}
            {/* <p
              style={{ cursor: "pointer" }}
              onClick={() => history.push(`${url}/${allData.id}/edit`)}
            >
              Edit
            </p> */}
            <p
              onClick={() =>
                setDeleteModalProps({
                  name: allData.itemName,
                  id: allData.id,
                  visible: true,
                })
              }
              style={{ color: "red", cursor: "pointer" }}
            >
              Delete
            </p>
          </Space>
        );
        return (
          <Popover content={content} trigger="click">
            <FiMoreVertical />
          </Popover>
        );
      },
    },
  ];

  useEffect(() => {
    (async () => {
      await dispatcher(getAllTransfarOrder());
    })();
    //  dispatcher(getAllTransfarOrder({ page: 0, size: 10 }));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const gotoAddOrder = () => {
    history.push(`${url}/add-order`);
  };

  const handleTableRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        history.push(`${url}/item-details`);
      },
    };
  };

  const handleItemDelete = async () => {
    try {
      setDeleteModalProps((prevState) => ({ ...prevState, loading: true }));
      await Services.deleteTransferOrder({
        id: deleteModalProps.id,
      });
      await dispatcher(getAllTransfarOrder({ page, size: rowsPerPage }));
      setFeedbackProps({
        type: "success",
        message: `${deleteModalProps.name} has been deleted`,
        open: true,
      });
      setDeleteModalProps((prevState) => ({
        ...prevState,
        loading: false,
        visible: false,
      }));
    } catch (error) {
      console.log(error);
      setDeleteModalProps((prevState) => ({ ...prevState, loading: false }));
      setFeedbackProps({
        type: "error",
        message: `Please try again`,
        open: true,
      });
    }
  };

  const onEditFinish = async (values) => {
    console.log(values, "editgruop");
    try {
      setEditModalProps((prevState) => ({ ...prevState, loading: true }));
      await Services.updateItemGroups({
        data: values,
        id: editModalProps.initialValues.id,
      });
      // await dispatcher(
      //   fetchItemGroupsByOrg({
      //     orgId: userProfile.organisation.orgId,
      //     page,
      //     size: rowsPerPage,
      //   })
      // );
      setEditModalProps((prevState) => ({
        ...prevState,
        loading: false,
        isVisible: false,
      }));
      notificationAlert(
        "success",
        "Item Group updated",
        `${editModalProps.initialValues.groupName} has been updated`
      );
    } catch (error) {
      setEditModalProps((prevState) => ({ ...prevState, loading: false }));
      if (error.response) {
        notificationAlert(
          "error",
          "Error Occurred",
          error.response.data.message || "Please try again later"
        );
      } else {
        notificationAlert("error", "Error Occurred", "Please try again later");
      }
    }
  };

  const filteredList = transfarOrderList.filter(
    (item) => item.id === searchItem
  );
  const displayItemlist =
    filteredList.length > 0 ? filteredList : transfarOrderList;
  return (
    <Switch>
      <Route exact path={path}>
        <ToolBar
          title="All Transfer Orders"
          showtools
          onCreate={gotoAddOrder}
          createButtonText="Create Transfer Order"
          valueName="itemName"
          dataList={transfarOrderList}
          setSearchItem={setSearchItem}
        />
        <StyledCard mt={2}>
          <TableWithPagination
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            columns={columns}
            dataSource={displayItemlist}
            // onRow={handleTableRow}
          />
        </StyledCard>

        <ModalScaffold
          form={editGroupForm}
          onCancel={() =>
            setEditModalProps((prevState) => ({
              ...prevState,
              isVisible: false,
            }))
          }
          title="Edit Item Group"
          visible={editModalProps.isVisible}
          loading={editModalProps.loading}
          onFinish={onEditFinish}
          initialValues={editModalProps.initialValues}
        >
          {editModalProps.selectedItemInput}
        </ModalScaffold>

        <DeleteModal
          open={deleteModalProps.visible}
          loading={deleteModalProps.loading}
          itemName={deleteModalProps.name}
          onClose={() =>
            setDeleteModalProps((prevState) => ({
              ...prevState,
              visible: false,
            }))
          }
          onDelete={handleItemDelete}
          title="Delete Warehouse"
        />
      </Route>
      <Route path={`${path}/add-order`}>
        <AddTransferOrder />
      </Route>
    </Switch>
  );
};

const ModalScaffold = (props) => {
  const onOk = () => {
    props.form.submit();
  };

  return (
    <StyledModal
      title={props.title}
      visible={props.visible}
      okButtonProps={{
        loading: props.loading,
        htmlType: "submit",
        style: {
          backgroundColor: themes.primaryColor,
          border: `1px solid ${themes.primaryColor}`,
        },
      }}
      cancelButtonProps={{
        type: "danger",
      }}
      onOk={onOk}
      okText="Create"
      onCancel={props.onCancel}
    >
      <Form
        initialValues={props.initialValues}
        form={props.form}
        {...layout}
        onFinish={props.onFinish}
      >
        {props.children}
      </Form>
    </StyledModal>
  );
};
